import { convertPackageWeightAndDimensions } from './package-unit-conversion-service';

export const convertPackagesWeightAndDimensions = (packages, weightUnit, dimensionsUnit) => {
  const validPackages = packages || [];
  return validPackages.map((parcel) => convertPackageWeightAndDimensions(parcel, weightUnit, dimensionsUnit));
};
